import { ProgressSpinner } from 'primereact/progressspinner';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Container from '../components/Container';
import ErrorMessage from '../components/ErrorMessage';
import { HttpRequestStatus } from '../components/types/types';
import { BSCI_ACCEPTANCE } from '../constants/pim-attributes';
import AppRoutes from '../constants/routes';
import useAccessorySupplier from '../hooks/useAccessorySupplier';
import useSupplierSettings from '../hooks/useSupplierSettings';

export default function RequireBsci() {
  const location = useLocation();

  const { t } = useTranslation();

  const { data, status } = useSupplierSettings();
  const { data: isAccessorySupplier, status: accessorySupplierStatus } = useAccessorySupplier();

  if (status === HttpRequestStatus.LOADING
    || accessorySupplierStatus === HttpRequestStatus.LOADING
  ) {
    return (
      <div className="text-center">
        <ProgressSpinner data-testid="loading-indicator" />
      </div>
    );
  }

  if (status === HttpRequestStatus.SUCCESS) {
    return data.values?.[BSCI_ACCEPTANCE] || !!isAccessorySupplier
      ? <Outlet />
      : <Navigate to={AppRoutes.ACCEPT_CODE_OF_CONDUCT} state={{ from: location }} replace />;
  }

  return (
    <Container size="sm">
      <ErrorMessage
        summary={t('code-of-conduct.message-could-not-check-acceptance')}
        detail={t('common.error.label-fetch-error-description')}
      />
    </Container>
  );
}
